import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Brand";

export function ProtectedRoute({ children, adminOnly = false }: { children: ReactNode; adminOnly?: boolean }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="grid min-h-screen place-items-center bg-background grain">
        <div className="animate-pulse">
          <Brand />
        </div>
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  // adminOnly is a UX guard only; the API enforces admin access server-side.
  if (adminOnly && !user.is_platform_admin) return <Navigate to="/simulator" replace />;
  return <>{children}</>;
}
